import { IBasicSkillFragment } from 'graphql/types';

export function isSkillSelected(
    selectedSkills: IBasicSkillFragment[],
    skill: IBasicSkillFragment
) {
    return selectedSkills.some(
        (selectedSkill) => selectedSkill.id === skill.id
    );
}

export function isSkillAdded(
    addedSkills: IBasicSkillFragment[],
    skill: IBasicSkillFragment
) {
    return addedSkills.some((addedSkill) => addedSkill.id === skill.id);
}

export function getSkillSelectStatus(
    selectedSkills: IBasicSkillFragment[],
    addedSkills: IBasicSkillFragment[],
    skill: IBasicSkillFragment
) {
    const isSelected = isSkillSelected(selectedSkills, skill);
    const isAdded = isSkillAdded(addedSkills, skill);

    return { isSelected, isAdded };
}
